export enum RelationInvoiceType {
  INVOICE = 'INVOICE',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export const InvoiceTypeTranslations: Record<RelationInvoiceType, string> = {
  [RelationInvoiceType.INVOICE]: 'Factuur',
  [RelationInvoiceType.DIRECT_DEBIT]: 'Automatische incasso',
};
